import { Box, Flex } from '@rebass/grid'
import * as React from 'react'
import { Text } from 'src/elements'
import styled from 'styled-components'
import Icon from '../Icon'

interface IPanelProps {
  isParticipant: boolean
  trial: boolean
  idx: number
  isOpen: boolean
  onToggle?: () => void
}

const PanelContainer = styled(Flex)`
  border-radius: 4px;
  background-color: #f7f8f8;
  align-items: center;
  padding: 16px 7px 16px 12px;
  @media (max-width: 992px) {
    border-radius: 0px;
  }
`

const SmScreenContent = styled(Box)`
  display: none;
  cursor: pointer;

  @media (max-width: 576px) {
    display: flex;
  }
`

const InsightLabel = styled(Box)`
  padding-right: 16px;
  margin-right: 16px;
  border-right: 1px solid rgba(0, 0, 0, 0.2);

  @media (max-width: 576px) {
    margin-right: 0px;
    padding-right: 0px;
    border: 0px;
  }
`

const LgScreenContent = styled(Flex)`
  display: flex;
  cursor: pointer;

  @media (max-width: 576px) {
    display: none;
  }
`

const Panel: React.SFC<IPanelProps> = ({
  children,
  idx,
  trial,
  isOpen,
  isParticipant,
  onToggle
}) => {
  return (
    <PanelContainer onClick={onToggle}>
      <Flex
        alignItems={['start', 'start', 'center', 'center']}
        mr="auto"
        flexDirection={['column', 'column', 'row', 'row']}
      >
        <InsightLabel>
          <Text.Description>觀點 {idx + 1}</Text.Description>
        </InsightLabel>
        <Text.SubtitleBold>{children}</Text.SubtitleBold>
        {trial && !isParticipant && (
          <SmScreenContent>
            <Icon
              type="icon-headset"
              style={{ width: '16px', height: '16px' }}
            />
          </SmScreenContent>
        )}
      </Flex>
      <Flex>
        {trial && !isParticipant && (
          <LgScreenContent mr={2} alignItems="center">
            <Box mr={1}>
              <Icon
                type="icon-headset"
                style={{ width: '16px', height: '16px' }}
              />
            </Box>
            <Box>
              <Text.ContentMainLight>試聽</Text.ContentMainLight>
            </Box>
          </LgScreenContent>
        )}
        <Box style={{ width: '32px', height: '32px' }}>
          {isOpen ? (
            <img src={require('./../../images/common/icon/icon-arrowup.svg')} />
          ) : (
            <img
              src={require('./../../images/common/icon/icon-arrowdown.svg')}
            />
          )}
        </Box>
      </Flex>
    </PanelContainer>
  )
}

export default Panel



// WEBPACK FOOTER //
// ./src/components/Chapter/Panel.tsx